<template>
  <div class="personal-information-form">

    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="userName" name="userName" v-model="user.title" type="text" class="form-control">
              <label for="userName">Title</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="firstName" name="firstName" v-model="user.firstName" type="text" class="form-control">
              <label for="firstName">First name</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="lastName" name="lastName" v-model="user.lastName" type="text" class="form-control">
              <label for="lastName">Title</label>
            </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="userEmail" name="userEmail" v-model="user.email" type="text" class="form-control">
              <label for="userEmail">Email</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="piStreetAndNumber" name="piStreetAndNumber" v-model="company.streetAndNumber" type="text" class="form-control">
              <label for="piStreetAndNumber">Company Street &amp; Number</label>
            </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="zip" name="zip" v-model="company.zip" type="text" class="form-control">
              <label for="zip">ZIP</label>
            </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="city" name="city" v-model="company.city" type="text" class="form-control">
              <label for="city">Company city</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="country" name="country" v-model="company.country" type="text" class="form-control">
              <label for="country">Company country</label>
            </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="state" name="state" v-model="company.state" type="text" class="form-control">
              <label for="state">State</label>
            </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="userPhone" name="userPhone" v-model="user.phone" type="text" class="form-control">
              <label for="userPhone">Mobile number</label>
            </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="userLandline" name="userLandline" v-model="user.landline" type="text" class="form-control">
              <label for="userLandline">Landline</label>
            </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="userFax" name="userFax" v-model="user.fax" type="text" class="form-control">
              <label for="userFax">Fax</label>
            </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="custom-file kp-file" v-file-input>
          <input type="file" class="custom-file-input" id="userIdCard" accept="image/*" capture>
          <label class="custom-file-label" for="userIdCard">
            <span class="file-placeholder">Upload personal ID card</span>
            <span class="file-name-holder"></span>
          </label>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="userBirthDate" name="userBirthDate" v-model="user.birthDate" type="text" class="form-control">
              <label for="userBirthDate">Date of birth</label>
            </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="userLanguage" name="userLanguage" v-model="user.language" type="text" class="form-control">
              <label for="userLanguage">Language</label>
            </div>
        </div>
      </div>
    </div>

    <div class="text-right mt-20">
      <button class="btn" @click="next()">Next</button>
    </div>

  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'personal-information-form',
  computed: {
    ...mapFields({
      user: 'user',
      company: 'company',
      currencies: 'currencies'
    })
  },
  methods: {
    next() {
      this.$emit('next')
    }
  }
}
</script>
